import { doCsvUploadForTransferArticulationMapping, getSelfReportedCourseList, setProgramCourseStatus, getProgramCourseList,getProgramEducation,getProgramCocurricular,getRelatedPrograms, getCatalogsForInstitution,
  getSelfReportedCourse, addSelfReportedCourse, deleteMultipleSelfReportedCourses, getSelfReportedProgramCountInfo,
  getTransferArticulationMappings, deleteAllTransferArticulationMappings, getProgramCourseProgress, redirectUserToCourseDashboard } from '../api'

export const loadTransferArticulationMappings = ({ state, commit }, {page, count, keyword}) => {
  return getTransferArticulationMappings(page, count, keyword)
}

export const loadDeleteAllTransferArticulationMappings = ({ state, commit }) => {
  return deleteAllTransferArticulationMappings()
}

export const uploadTransferArticulationMappingCsvFile = ({ state, commit }, {fileData}) => {
  return doCsvUploadForTransferArticulationMapping(fileData)
}

export const loadSelfReportedCourseList = ({ state, commit }, keyword) => {
  return getSelfReportedCourseList(keyword)
}

export const loadProgramCourseList = ({ state, commit }, streamId) => {
  return getProgramCourseList(streamId)
}
export const loadProgramEducation = ({ state, commit }, streamId) => {
  return getProgramEducation(streamId)
}
export const loadProgramCocurricular = ({ state, commit }, streamId) => {
  return getProgramCocurricular(streamId)
}
export const loadRelatedPrograms = ({ state, commit }, programId) => {
  return getRelatedPrograms(programId)
}

export const updateProgramCourseStatus = ({ state, commit }, streamId, status) => {
  return setProgramCourseStatus(streamId,status)
}

export const loadProgramCourseProgress = ({ state, commit }, courseId) => {
  return getProgramCourseProgress(courseId)
}

export const navigateUserToCourseDashboard = ({ state, commit }, data) => {
  return redirectUserToCourseDashboard(data)
}

export const loadCatalogsForInstitution = ({ state, commit }, openId) => {
  return getCatalogsForInstitution(openId)
}

export const loadSelfReportedCourse = ({ state, commit }, uuid) => {
  return getSelfReportedCourse(uuid)
}

export const loadAddSelfReportedCourse = ({ state, commit }, data) => {
  return addSelfReportedCourse(data)
}

export const deleteSelfReportedCourses = ({ state, commit }, itemsToDelete) => {
  return deleteMultipleSelfReportedCourses(itemsToDelete)
}

export const loadSelfReportedProgramCountInfo = ({ state, commit }) => {
  return getSelfReportedProgramCountInfo()
}



// WEBPACK FOOTER //
// ./src/app/transfer/vuex/actions.js